import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pesc-type-form',
  templateUrl: './pesc-type-form.component.html',
  styleUrls: ['./pesc-type-form.component.css']
})
export class PescTypeFormComponent implements OnInit {

  title = "Add Project Environment and Safety Compliances";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/pe-sc-type/pesc-type-form/pesc-type-form.component.ts